<template>
  <div class="notifications">
    <h1 class="notifications__title">Уведомления</h1>

    <BaseBtn
      v-if="(configAccess.notifications.main === 2) && (getDealer.has_sub_dealers)"
      @btnClick="updatePopup(true, 'PopupNotification')"
      class="notifications__add-btn"
      text="Добавить уведомление"/>

    <ul v-if="notifications && notifications.data" class="notifications__list">
      <Item
        v-for="(item, index) in notifications.data"
        :key="index"
        :item="item"
        :index="index"/>
    </ul>
    <Pagination
      v-if="notifications && notifications.pagination.last_page > 1"
      :pagination="notifications.pagination"
      :per_page="false"
      @updatePagination="updatePagination"/>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from "vuex";

export default {
  components: {
    Item: () => import('./components/Item'),
    Pagination: () => import('@/pages/account/components/Pagination'),
    BaseBtn: () => import('@/components/base/BaseBtn')
  },

  computed: {
    ...mapState({
      configAccess: state => state.user.configAccess,
      notifications: state => state.account.notifications,
    }),

    ...mapGetters('user', [
      'getDealerName',
      'getDealer',
    ]),
  },

  metaInfo() {
    return {
      title: `Уведомления - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  methods: {
    ...mapActions('account', [
      'loadNotifications',
    ]),

    updatePagination(page) {
      // TODO:: КОСТЫЛЬ! Не знаю как сделать по-другому закрыть описания уведомления до перехода пагинации
      this.$forceUpdate()

      this.loadNotifications(page);
      this.$router.push({
        query: {
          page
        }
      }).catch(() => {
      });
    },
  },

  created() {
    let page = this.$route.query.page;
    if (!page) {
      page = 1;
      this.$router.push({
        query: {
          'page': page,
        }
      }).catch(() => {
      });
    }
    this.loadNotifications(page);
  },
}
</script>

<style scoped lang="scss">
.notifications {
  padding: 20px 15px 70px;

  @media(max-width: $desktop) {
    padding: 0 0 20px;
  }

  &__add-btn {
    margin-bottom: 20px;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media(max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }

  &__list {
    margin: 0 auto;
    width: 100%;
    max-width: 600px;
  }
}
</style>
